export const MAX_AGE = 60 * 60 * 24
